/**
 * @bos/portal3 — the catch-all 404 page (route `*`). A calm standalone screen: the
 * Sorvel seal, a plain explanation, and a way back. Proves unknown URLs resolve to a
 * real in-app page rather than a blank screen or a server error.
 */
import { Link } from 'react-router-dom';
import { PATHS } from '../routes';
import { Brand } from '../components/Brand';

export function NotFoundPage() {
  return (
    <div className="centered">
      <div className="centered__inner">
        <Brand size="lg" />
        <p className="eyebrow">Error 404</p>
        <h1 className="centered__title">Page not found</h1>
        <p className="centered__lede">That link doesn’t match anything in Sorvel.</p>
        <Link to={PATHS.landing} className="btn btn--primary">
          Back to Sorvel
        </Link>
      </div>
    </div>
  );
}
